import { StatsTable, SpeciesData } from './dex-species';

/* eslint-disable max-len */
export const MYTHICALS: number[] = [151, 251, 385, 386, 489, 490, 491, 492, 493, 494, 647, 648, 649, 719, 720, 721, 801, 802, 807, 808, 809, 893, 1025];
export const SUB_LEGENDARIES: number[] = [144, 145, 146, 243, 244, 245, 377, 378, 379, 380, 381, 480, 481, 482, 485, 486, 488, 638, 639, 640, 641, 642, 645, 772, 773, 785, 786, 787, 788, 891, 892, 894, 895, 896, 897, 905, 1001, 1002, 1003, 1004, 1014, 1015, 1016];
export const LEGENDARIES: number[] = [150, 249, 250, 382, 383, 384, 483, 484, 487, 643, 644, 646, 716, 717, 718, 789, 790, 791, 792, 800, 888, 889, 890, 898, 1007, 1008, 1017, 1024];
export const TYPES: string[] = ['Normal', 'Fire', 'Water', 'Ground', 'Electric', 'Fairy', 'Grass', 'Rock', 'Steel', 'Ice', 'Ghost', 'Psychic', 'Dark', 'Bug', 'Fighting', 'Poison', 'Flying', 'Dragon'];
export const BABY_POKEMON: number[] = [172, 173, 174, 175, 236, 238, 239, 240, 298, 360, 406, 433, 438, 439, 440, 446, 447, 458, 848];
/* eslint-enable max-len */

export const TYPES_TO_COLORS: { [key: string]: number[] } = {
  Normal: [168, 167, 122],
  Fire: [238, 129, 48],
  Water: [99, 144, 240],
  Electric: [247, 208, 44],
  Grass: [122, 199, 76],
  Ice: [150, 217, 214],
  Fighting: [194, 46, 40],
  Poison: [163, 62, 161],
  Ground: [226, 191, 101],
  Flying: [169, 143, 243],
  Psychic: [249, 85, 135],
  Bug: [166, 185, 26],
  Rock: [182, 161, 54],
  Ghost: [115, 87, 151],
  Dragon: [111, 53, 252],
  Dark: [112, 87, 70],
  Steel: [183, 183, 206],
  Fairy: [214, 133, 173],
  Average: [148, 163, 184],
};
/* eslint-disable max-len */
export const ULTRA_BEASTS: number[] = [793, 794, 795, 796, 797, 798, 799, 803, 804, 805, 806];
export const PAST_PARADOX: number[] = [984, 985, 986, 987, 988, 989, 1005, 1007, 1009, 1020, 1021];
export const FUTURE_PARADOX: number[] = [990, 991, 992, 993, 994, 995, 1006, 1008, 1010, 1022, 1023];
export const REGIONAL_SUFFIX: string[] = ['-hisui', '-galar', '-alola', '-paldea'];
export const PIKACHU_COSPLAY_FORMES: string[] = ['-rock-star', '-belle', '-pop-star', '-phd', '-libre'];
export const PIKACHU_CAP_FORMES: string[] = ['-original', '-hoenn', '-sinnoh', '-unova', '-kalos', 'pikachu-alola', '-world'];
export const PIKACHU_OTHER_FORMES: string[] = ['-partner'];
/* eslint-enable max-len */
export const GENERATIONS: { name: string, value: number }[] = [
  { name: 'Gen 1', value: 1 },
  { name: 'Gen 2', value: 2 },
  { name: 'Gen 3', value: 3 },
  { name: 'Gen 4', value: 4 },
  { name: 'Gen 5', value: 5 },
  { name: 'Gen 6', value: 6 },
  { name: 'Gen 7', value: 7 },
  { name: 'Gen 8', value: 8 },
  { name: 'Gen 9', value: 9 },
];

export type BaseStatsType = {
  name: string,
  abv: string,
  value: string,
};

export const BASE_STATS: BaseStatsType[] = [
  { name: 'HP', abv: 'HP', value: 'hp' },
  { name: 'Attack', abv: 'Atk', value: 'atk' },
  { name: 'Defense', abv: 'Def', value: 'def' },
  { name: 'Special Attack', abv: 'SpA', value: 'spa' },
  { name: 'Special Defense', abv: 'SpD', value: 'spd' },
  { name: 'Speed', abv: 'Spe', value: 'spe' },
];

export const SORT_NONE: number = -1;
export const SORT_ASCENDING: number = 0;
export const SORT_DESCENDING: number = 1;

export const contains = (array: any[], obj: any) => {
  let i = array.length;
  while (i--) { // eslint-disable-line no-plusplus
    if (array[i] === obj) return true;
  }
  return false;
};

export const containsSuffix = (suffix: string, str: string) => str.includes(suffix);

export const getPokedexSpeciesIdKey = (speciesName: string): string => speciesName.toLowerCase().replace('-', '');

export const sum = (partialSum: number, currentValue: number) => partialSum + currentValue;

export const getSpeciesIdGivenName = (
  name: string,
  Pokedex: { [speciesid: string]: SpeciesData },
): string | null => {
  const speciesIds = Object.keys(Pokedex);
  let index = 0;
  while (index < speciesIds.length) {
    const stats = Pokedex[speciesIds[index]];
    if (stats.name === name) return speciesIds[index];
    index += 1;
  }
  return null;
};

export const getEvolutionFamily = (
  speciesId: string,
  Pokedex: { [speciesid: string]: SpeciesData },
): string[][] => {
  const evolutionFamily = [[speciesId]];
  const stats = Pokedex[speciesId];

  // Get all prevo
  let { prevo } = stats;
  while (prevo !== undefined || prevo != null) {
    evolutionFamily.unshift([prevo]);
    prevo = Pokedex[prevo]?.prevo;
  }

  const { evos } = stats;
  if (evos !== undefined || evos != null) {
    evolutionFamily.push(evos);
  }

  return evolutionFamily;
};

export const addAllBaseStats = (
  baseStats: StatsTable,
): number => Object.values(baseStats).reduce(sum);

export const getFormeName = (stats: SpeciesData) => {
  const { name, baseSpecies } = stats;
  if (baseSpecies === undefined) return [name, null];
  return [name, name.split(baseSpecies)[1]];
};

export const beautifyPokemonName = (name: string) => {
  if (name === 'Porygon-Z') return name;
  if (name === 'Nidoran-M') return 'Nidoran♂';
  if (name === 'Nidoran-F') return 'Nidoran♀';
  return name
    .replaceAll('-', ' ');
};

export const getBaseSpeciesGenByPokedexNumber = (num: number): number => {
  if (num <= 0) return -1;
  if (num <= 151) return 1;
  if (num <= 251) return 2;
  if (num <= 386) return 3;
  if (num <= 493) return 4;
  if (num <= 649) return 5;
  if (num <= 721) return 6;
  if (num <= 809) return 7;
  if (num <= 905) return 8;
  if (num <= 1025) return 9;
  return 0;
};

export const getGenIntroducedByStats = (stats: SpeciesData): number => {
  const name = stats.name.toLowerCase();
  if (name.includes('-paldea')) return 9;
  if (name.includes('-gmax')
    || name.includes('-galar')
    || name.includes('-hisui')) return 8;
  if (name.includes('-alola') && !name.includes('pikachu')) return 7;
  if (name.includes('-mega')
    || name.includes('-primal')
    || name.includes('pikachu-')
    || (name.includes('-origin') && !name.includes('giratina'))) return 6;
  return getBaseSpeciesGenByPokedexNumber(stats.num);
};

export const filterByGenerations = (
  Pokedex: { [speciesid: string]: SpeciesData },
  gensAllowed: { [key: string]: boolean },
) => {
  const gensAllowedArray = Object.keys(gensAllowed)
    .map((gen: string): number => {
      if (gensAllowed[gen]) return parseInt(gen, 10);
      return 0;
    })
    .filter((gen: number) => gen !== 0);
  // Object.keys(Pokedex)
  // .filter(filterByGeneration(Pokedex: {[speciesid: string]: SpeciesData}, gensAllowedArray))
  return (speciesId: string): boolean => contains(
    gensAllowedArray,
    getGenIntroducedByStats(Pokedex[speciesId]),
  );
};

export const filterByTypes = (
  Pokedex: { [speciesid: string]: SpeciesData },
  typesAllowed: { [key: string]: boolean },
) => {
  const typesAllowedArray = Object.keys(typesAllowed)
    .map((type: string): string | null => {
      if (typesAllowed[type]) return type;
      return null;
    })
    .filter((type: string | null): boolean => type != null);
  if (typesAllowedArray.length === 0) return () => true;
  return (speciesId: string): boolean => Pokedex[speciesId].types.some(
    (type: string) => contains(typesAllowedArray, type),
  );
};

export const filterByTypesInclusive = (
  Pokedex: { [speciesid: string]: SpeciesData },
  typesAllowed: string[],
) => {
  if (typesAllowed.length === 0) return () => true;
  const typesSelected = new Set(typesAllowed);
  return (speciesId: string): boolean => {
    let counter = 0;
    const monTypes = Pokedex[speciesId].types;
    monTypes.forEach((type: string) => {
      if (typesSelected.has(type)) counter += 1;
    });
    return counter === typesAllowed.length;
  };
};

export const filterBaseSpecies = (
  Pokedex: { [speciesid: string]: SpeciesData },
  baseSpeciesAllowed: boolean = false,
) => {
  if (baseSpeciesAllowed) return () => true;
  return (speciesId: string): boolean => 'baseSpecies' in Pokedex[speciesId];
};

export const countBaseSpecies = (
  Pokedex: { [speciesid: string]: SpeciesData },
  speciesIds: string[],
): number => {
  const unique = new Set<number>();
  speciesIds.forEach((speciesId) => {
    const { num } = Pokedex[speciesId];
    unique.add(num);
  });
  return unique.size;
};

export const filterMegas = (
  Pokedex: { [speciesid: string]: SpeciesData },
  megasAllowed = true,
) => {
  if (megasAllowed) return () => true;
  return (speciesId: string): boolean => {
    const name = Pokedex[speciesId].name.toLowerCase();
    return !name.includes('-mega') && !name.includes('-primal') && !name.includes('-ultra');
  };
};

export const filterGMaxes = (
  Pokedex: { [speciesid: string]: SpeciesData },
  gmaxAllowed = true,
) => {
  if (gmaxAllowed) return () => true;
  return (speciesId: string): boolean => !Pokedex[speciesId].name.toLowerCase().includes('-gmax');
};

export const filterLegendaries = (
  Pokedex: { [speciesid: string]: SpeciesData },
  legendariesAllowed = true,
) => {
  if (legendariesAllowed) return () => true;
  return (speciesId: string): boolean => {
    const { num } = Pokedex[speciesId];
    return !contains(LEGENDARIES, num) && !contains(SUB_LEGENDARIES, num);
  };
};

export const filterMythicals = (
  Pokedex: { [speciesid: string]: SpeciesData },
  mythicalsAllowed = true,
) => {
  if (mythicalsAllowed) return () => true;
  return (speciesId: string): boolean => !contains(MYTHICALS, Pokedex[speciesId].num);
};

export const filterByStats = (
  Pokedex: { [speciesid: string]: SpeciesData },
  stat: string,
  statRange: number[],
) => {
  if (statRange[0] === 1 && statRange[1] === 255) return () => true;
  return (speciesId: string): boolean => {
    const { baseStats } = Pokedex[speciesId];
    return baseStats[stat] >= statRange[0] && baseStats[stat] <= statRange[1];
  };
};

export const filterRegionals = (
  Pokedex: { [speciesid: string]: SpeciesData },
  regionalsAllowed = true,
) => {
  if (regionalsAllowed) return () => true;
  return (speciesId: string): boolean => !REGIONAL_SUFFIX.some(
    (suffix: string): boolean => containsSuffix(suffix, Pokedex[speciesId].name.toLowerCase()),
  );
};

export const filterBaseFormesPermanentFormes = (
  Pokedex: { [speciesid: string]: SpeciesData },
) => (speciesId: string): boolean => {
  const { name } = Pokedex[speciesId];
  if (name === 'Dialga-Origin'
    || name === 'Palkia-Origin'
    || name === 'Giratina-Origin'
    || name === 'Shaymin-Sky'
    || name === 'Tornadus-Therian'
    || name === 'Thundurus-Therian'
    || name === 'Landorus-Therian'
    || name === 'Enamorus-Therian'
    || name === 'Indeedee-F'
    || name === 'Basculin-White-Striped'
    || name === 'Basculegion-F'
    || name === 'Meowstic-F'
    || name === 'Zygarde-10%'
    || name === 'Zygarde-Complete'
    || name === 'Hoopa-Unbound'
    || name === 'Necrozma-Dusk-Mane'
    || name === 'Necrozma-Dawn-Wings'
    || name === 'Zacian-Crowned'
    || name === 'Zamazenta-Crowned'
    || name === 'Urshifu-Rapid-Strike'
    || name === 'Ursaluna-Bloodmoon'
    || name.includes('Ogerpon-')
    || name.includes('Kyurem-')
    || name.includes('Calyrex-')
    || name.includes('Oricorio-')
    || name.includes('Lycanroc-')
    || name.includes('Castform-')
    || name.includes('Deoxys-')
    || name.includes('Wormadam-')
    || name.includes('Rotom-')
    || name.includes('Terapagos-')
  ) {
    return false;
  }
  return true;
};

export const filterBaseFormesBattleOnlyFormesNonMegaNonGigantamax = (
  Pokedex: { [speciesid: string]: SpeciesData },
) => (speciesId: string): boolean => {
  const { name } = Pokedex[speciesId];
  if (name === 'Cherrim-Sunshine'
    || name === 'Darmanitan-Zen'
    || name === 'Wishiwashi-School'
    || name === 'Minior-Meteor'
    || name === 'Palafin-Hero'
    || name === 'Eiscue-Noice'
    || name === 'Greninja-Ash'
    || name === 'Aegislash-Blade'
    || name === 'Meloetta-Pirouette'
    || name === 'Terapagos-Terastal'
    || name === 'Terapagos-Stellar'
  ) {
    return false;
  }
  return true;
};

export const filterBaseFormes = (
  Pokedex: { [speciesid: string]: SpeciesData },
  baseFormesAllowed = true,
) => {
  if (baseFormesAllowed) return () => true;
  const filterBF = filterBaseFormesPermanentFormes(Pokedex);
  const filterBFBattlesOnly = filterBaseFormesBattleOnlyFormesNonMegaNonGigantamax(Pokedex);
  return (speciesId: string): boolean => filterBF(speciesId) && filterBFBattlesOnly(speciesId);
};

export const getBaseStatsAverageGivenSpeciesIds = (
  Pokedex: { [speciesid: string]: SpeciesData },
  speciesIds: string[],
): StatsTable => {
  const result: { [key: string]: number } = {};
  BASE_STATS.forEach((stat: BaseStatsType) => {
    result[stat.abv] = 0;
  });
  if (speciesIds.length === 0) return result;
  speciesIds.forEach((speciesId: string): void => {
    const { baseStats } = Pokedex[speciesId];
    BASE_STATS.forEach((stat: BaseStatsType) => {
      result[stat.abv] += baseStats[stat.value];
    });
  });
  BASE_STATS.forEach((stat: BaseStatsType) => {
    result[stat.abv] = Math.round(result[stat.abv] / speciesIds.length);
  });
  return result;
};

export const getRandomInt = (length: number): number => Math.floor(Math.random() * length);

/* Functions from this line are only used by dexEnhance script */
export const filterMultiTypesArceusSylvallyOnly = (
  Pokedex: { [speciesid: string]: SpeciesData },
) => (speciesId: string): boolean => !TYPES.some(
  (suffix: string): boolean => {
    const { name } = Pokedex[speciesId];
    return containsSuffix(`-${suffix.toLowerCase()}`, name.toLowerCase())
      && (name.includes('Arceus') || name.includes('Silvally'));
  },
);

export const filterOgerponTeraFormes = (
  Pokedex: { [speciesid: string]: SpeciesData },
) => (speciesId: string): boolean => {
  const { name } = Pokedex[speciesId];
  if (name === 'Ogerpon-Teal-Tera'
    || name === 'Ogerpon-Wellspring-Tera'
    || name === 'Ogerpon-Hearthflame-Tera'
    || name === 'Ogerpon-Cornerstone-Tera'
  ) {
    return false;
  }
  return true;
};

export const isLegendary = (
  speciesId: string,
  Pokedex: { [speciesid: string]: SpeciesData },
): boolean => {
  const { num } = Pokedex[speciesId];
  return LEGENDARIES.includes(num) || SUB_LEGENDARIES.includes(num);
};

export const isMythical = (
  speciesId: string,
  Pokedex: { [speciesid: string]: SpeciesData },
): boolean => MYTHICALS.includes(Pokedex[speciesId].num);

export const isFullyEvolved = (
  speciesId: string,
  Pokedex: { [speciesid: string]: SpeciesData },
): boolean => Pokedex[speciesId].evos === undefined;

export const isBabyPokemon = (
  speciesId: string,
  Pokedex: { [speciesid: string]: SpeciesData },
): boolean => BABY_POKEMON.includes(Pokedex[speciesId].num);

export const isParadoxPokemon = (
  speciesId: string,
  Pokedex: { [speciesid: string]: SpeciesData },
): boolean => {
  const { num } = Pokedex[speciesId];
  return PAST_PARADOX.includes(num) || FUTURE_PARADOX.includes(num);
};

export const isUltraBeast = (
  speciesId: string,
  Pokedex: { [speciesid: string]: SpeciesData },
): boolean => ULTRA_BEASTS.includes(Pokedex[speciesId].num);

export const filterCosmeticFormes = (
  Pokedex: { [speciesid: string]: SpeciesData },
) => (speciesId: string): boolean => {
  const { name } = Pokedex[speciesId];
  if (name === 'Mimikyu-Busted'
    || name === 'Xerneas-Neutral'
    || name === 'Floette-Eternal'
    || name === 'Magearna-Original'
    || name === 'Pichu-Spiky-eared'
    || name === 'Toxtricity-Low-Key'
    || name === 'Morpeko-Hangry'
    || name === 'Dudunsparce-Three-Segment'
    || name === 'Cramorant-Gulping'
    || name === 'Cramorant-Gorging'
    || name === 'Greninja-Bond'
    || name === 'Keldeo-Resolute'
    || name === 'Maushold-Four'
    || name === 'Oinkologne-F'
    || name === 'Basculin-Blue-Striped'
    || name === 'Zarude-Dada'
    || name === 'Eevee-Starter' // Pokemon Let's Go only
    || name === 'Poltchageist-Artisan'
    || name === 'Sinistcha-Masterpiece'
    || name === 'Toxtricity-Low-Key-Gmax'
    || name.includes('Unown-') // Remove all Unowns formes
    || (name.includes('Pikachu-') && name !== 'Pikachu-Gmax')
    || name.includes('Vivillon-')
    || name.includes('Pumpkaboo-')
    || name.includes('Gourgeist-')
    || name.includes('-Antique')
    || name.includes('Squawkabilly-')
    || name.includes('Genesect-')
  ) {
    return false;
  }
  return true;
};

export const filterUnplayables = (
  Pokedex: { [speciesid: string]: SpeciesData },
) => (speciesId: string): boolean => {
  const { name } = Pokedex[speciesId];
  if (name === 'Eternatus-Eternamax'
    || name === 'Gimmighoul-Roaming'
    || name.includes('-Totem')
  ) {
    return false;
  }
  return true;
};
